import posthog from "posthog-js";
import { detectDisplayMode } from "./pwaHelper";

export const posthogCapture = (eventName, properties={}) => {
  posthog.capture(eventName, {
    ...properties,
    env: process.env.NODE_ENV,
    display: detectDisplayMode()
  })
}